import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Image, Picture } from "./PictureWithModilePixel.styles";
var PictureWithMobilePixel = function(props) {
    return /*#__PURE__*/ _jsxs(Picture, {
        children: [
            /*#__PURE__*/ _jsx("source", {
                srcSet: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
                media: "(max-width: 36rem)"
            }),
            /*#__PURE__*/ _jsx(Image, _object_spread({}, props))
        ]
    });
};
export { PictureWithMobilePixel };
